import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/primeng';
import { DeviceService } from '../services/device.service';
import { UserService} from '../services/user.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-device-without-reporting',
  templateUrl: './device-without-reporting.component.html',
  styleUrls: ['./device-without-reporting.component.css']
})
export class DeviceWithoutReportingComponent implements OnInit {
  cols: any[];
  fileName:string;
  msgs: Message[] = [];
  blockedDocument: boolean = false;
  devices:any[];
  hours:number=24;
  overlays: any[];
  displayLocation: boolean=false;
  options: any;
  device:any;

  constructor(private deviceService:DeviceService,private userService:UserService) { }

  ngOnInit() {
    this.cols = [
            { field: 'nro', header: 'NRO.' },
            { field: 'idDevice', header: 'ID' },
            { field: 'name', header: 'NOMBRE' },
            { field: 'usersNicknames', header: 'USUARIOS' },
            { field: 'company', header: 'EMPRESA' },
            { field: 'lastUpdate', header: 'FECHA/HORA ULTIMO REPORTE' },
            { field: 'phone', header: 'TELEFONO' }
        ];
  }

  buscar(){
    this.fileName="equiposSinReportase";
    this.blockedDocument = true;
    this.devices = [];
    this.deviceService.findDevicesWithoutReportingByUser(this.userService.userLoged.idUser,this.hours).then(data => {
      let response: any = data;
      if(response.status != "OK"){
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        this.blockedDocument = false;
        return;
      }
      response.devices.forEach((item,i) => {
        item.usersNicknames = "";
        item.company = "";
        item.users.forEach(user=>{
          item.usersNicknames += user.nickName+"\n";
          item.company = user.company;
        });
        item.nro = i+1;
        this.devices.push(item);

      });
      this.blockedDocument = false;
    }).catch(err =>{
      console.error(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Error de conexión, comprueba la conexión a internet y vuelva a intentar"}];
      this.blockedDocument = false;
    });
  }

  exportXLS(){
    let records = [];
    this.devices.forEach(item=>{
      let data = {};
      this.cols.forEach(col => {
        data[col.header] = item[col.field];
      });
      records.push(data);
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.fileName+".xlsx");
  }

  showInMap(device:any){
    this.overlays = [];
    this.displayLocation = true;
    let latLng = new google.maps.LatLng(device.latitude, device.longitude);
    this.options = {
      zoom: 13,
      center:latLng
    };
    let marker = new google.maps.Marker({position: latLng});
    this.device = device;
    this.overlays.push(marker);
  }

  showMonitoring(device:any){
    let parameters = {idDevice:device.idDevice,idUser:this.userService.userLoged.idUser,phone:device.phone};
    window.open(window.location.href.replace("deviceWithoutReporting","monitoring?token="+btoa(JSON.stringify(parameters))), "_blank");
  }

  hide(){
    this.displayLocation = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/device-without-reporting/device-without-reporting.component.ts